import * as React from "react";
import {useEffect} from "react";
import AceEditor from 'react-ace';
import {Button, Label, Segment} from "semantic-ui-react";
import {ConfigContext} from "../../../../context/ConfigContext";
import 'brace/ext/searchbox'
import {ConverterSendButton} from "../../ConverterSendButton";
import {
    AdditionalDataEntry,
    AttachmentStatus,
    QueuedEvent,
    TransportOrderStatus
} from "../../../../../../generated/api";
import {signal, Signal} from "@preact/signals-react";
import {exportSimOutputIndex} from "./ExportSimPrepareSide";
import StatusCodeEnum = AttachmentStatus.StatusCodeEnum;


export const queuedEvents: Signal<QueuedEvent[]> = signal([]);

export interface ExportSimQueuedEventEditorProps {
    triggerQueuedEventDirectly: (queuedEvents: QueuedEvent[]) => Promise<void>
}

export function ExportSimQueuedEventEditor(props: ExportSimQueuedEventEditorProps) {
    const context = React.useContext(ConfigContext);

    const [valid, setValid] = React.useState(true);
    const [isInputMissing, setIsInputMissing] = React.useState(false);
    const [queuedEventText, setQueuedEventText] = React.useState("");

    useEffect(() => {
        setCurrentEvent()
    }, []);

    useEffect(() => {
        setCurrentEvent(exportSimOutputIndex.value)
    }, [exportSimOutputIndex.value]);

    function setCurrentEvent(index: number = exportSimOutputIndex.value) {
        console.log("ExportSimQueuedEventEditor: setCurrentEvent, eventIndex: ", index);
        if (queuedEvents.value.length > 0) {
            setQueuedEventText(JSON.stringify(queuedEvents.value[index], null, 4));
        }
    }

    function handleQueuedEventChange(value: string) {
        if (value == queuedEvents.value[exportSimOutputIndex.value]) {
            console.log("ExportSimQueuedEventEditor: no change");
            return;
        }
        try {
            if (value != "") {
                let parsed = JSON.parse(value);
                setValid(true);
                let statusCode = parsed.transportOrderEvent?.transportOrder?.status?.statusCode;
                console.log("ExportSimQueuedEventEditor: statusCode: ", statusCode);
                setIsInputMissing(statusCode === TransportOrderStatus.StatusCodeEnum.INPUTMISSING)
                context.setExportSimQeValid("true");
                queuedEvents.value[exportSimOutputIndex.value] = JSON.parse(value);
            }
        } catch (ex: any) {
            console.error("ExportSimQueuedEventEditor: invalid JSON", ex);
            setValid(false);
            setIsInputMissing(false);
            context.setExportSimQeValid("false");
        }

        setQueuedEventText(value);
    }

    function queuedEventSelector() {
        function queuedEventButton(event: QueuedEvent, index: number) {
            let eventName = "Event " + (index + 1);

            let toId = event.transportOrderEvent?.transportOrder?._id;
            if (toId != null) {
                eventName = "TO ID: " + toId;
            }

            return <Button
                key={"queuedEventButton_" + index}
                primary={index === exportSimOutputIndex.value}
                onClick={() => {
                    exportSimOutputIndex.value = index
                    console.log("ExportSimQueuedEventEditor: queuedEventButton clicked, index: ", index);
                }}
            >
                {eventName}
            </Button>

        }

        return <div style={{marginBottom: "10px"}}>
            {queuedEvents.value.map((event, index) => queuedEventButton(event, index))}
        </div>;

    }

    async function resolveStatus() {
        let kdnr = {} as AdditionalDataEntry;
        kdnr.key = "kundenNr";
        kdnr.value = "7777777777777";

        let queuedEvent = JSON.parse(context.exportSimQe);
        let transportOrder = queuedEvent.transportOrderEvent?.transportOrder;

        if (transportOrder == null) {
            console.error("ExportSimQueuedEventEditor: transportOrder is null");
            return;
        }

        transportOrder.transports.forEach(t => {
            t.stops.forEach(stop => {
                if (stop.additionalData != null) {
                    if (stop.additionalData.find(ad => ad.key == "kundenNr") == undefined) {
                        stop.additionalData.push(kdnr);
                    }
                } else {
                    stop.additionalData = [kdnr];
                }
            });
        });
        transportOrder.freight.forEach(f => {
            f.contractingParties.forEach(cp => {
                if (cp.additionalData != null) {
                    if (cp.additionalData.find(ad => ad.key == "kundenNr") == undefined) {
                        cp.additionalData.push(kdnr);
                    }
                } else {
                    cp.additionalData = [kdnr];
                }
            });
        });

        transportOrder.status.statusCode = StatusCodeEnum.ACCEPTED;

        queuedEvent.transportOrderEvent.transportOrder = transportOrder;
        let newQueuedEvent = JSON.stringify(queuedEvent, null, 4);
        handleQueuedEventChange(newQueuedEvent);

    }

    function canBeSent(): boolean {
        return valid && !isInputMissing && queuedEvents.value.length > 0 && queuedEventText != "";
    }

    return (
        <>
            <div style={{marginBottom: "5px"}}>
                <ConverterSendButton
                    disabled={!canBeSent()}
                    onClick={() => props.triggerQueuedEventDirectly(queuedEvents.value)}
                />
            </div>

            {!valid ?
                <Label size={'huge'} color='red' pointing="below">INVALID JSON</Label> : null}
            {isInputMissing ? <>
                <Segment textAlign={'center'}>
                    <Label color={'yellow'}>
                        The status is INPUT_MISSING. This won&apos;t work on the Converter.
                    </Label>
                    <br/>
                    <Button
                        onClick={resolveStatus}
                    >
                        Resolve
                    </Button>
                </Segment>
                <br/>
            </> : null
            }

            {queuedEventSelector()}
            <AceEditor
                theme="monokai"
                style={{flex: 1}}
                mode='json'
                value={queuedEventText}
                placeholder='QueuedEvent'
                width="100%"
                onChange={handleQueuedEventChange}
                readOnly={false}
            />
        </>
    );
}